import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: "Home", path: "/" },
    { name: "About", path: "/about" },
    { name: "Events", path: "/events" },
    { name: "Resources", path: "/resources" },
    { name: "Members", path: "/members" },
    { name: "Register", path: "/registration" },
    { name: "Gallery", path: "/gallery" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-gradient-to-r from-black to-indigo-700 text-white shadow-lg">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo and Site Name */}
          <div className="flex items-center space-x-2">
            <Link to="/">
              <img
                src="https://i.ibb.co/vDHPhYX/gam-INDlogo.jpg"
                alt="Gam-India Logo"
                className="w-10 h-10 sm:w-14 sm:h-14 rounded-full border-2 border-white cursor-pointer"
              />
            </Link>
            <Link to="/">
              <div>
                <h1 className="text-xl sm:text-3xl font-bold">Gam-Ind</h1>
                <p className="text-xs sm:text-sm">Students Association</p>
              </div>
            </Link>
          </div>

          {/* Navigation for larger screens */}
          <nav className="hidden lg:flex space-x-6">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`hover:text-yellow-300 transition duration-300 ease-in-out ${
                  isActive(item.path) ? "text-yellow-300 font-bold" : ""
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* Hamburger menu button for mobile and tablet */}
          <button
            className="lg:hidden text-white focus:outline-none"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg
              className="h-6 w-6"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                d={
                  isMenuOpen
                    ? "M6 18L18 6M6 6l12 12"
                    : "M4 6h16M4 12h16M4 18h16"
                }
              ></path>
            </svg>
          </button>
        </div>

        {/* Mobile and Tablet menu */}
        <div className={`lg:hidden ${isMenuOpen ? "block" : "hidden"} mt-4`}>
          <nav className="flex flex-col space-y-2">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`block px-3 py-2 rounded-md text-base font-medium hover:bg-indigo-600 hover:text-white transition duration-300 ease-in-out ${
                  isActive(item.path) ? "bg-indigo-600 text-white" : ""
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                {item.name}
              </Link>
            ))}
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
